import axios from 'axios';

import { IS_CLIENT_SIDE } from '@dr.pogodin/react-utils';

import type {
  GetLatestUserScoresQueryT,
  GetLatestUserScoresResT,
} from 'server/controllers/user-scores';

import {
  E_SCORES,
  P_API_USERS,
  type UserScoreKindT,
  type UserScoreT,
} from 'utils';

export async function getLatestUserScores(
  userId: string,
  kinds: UserScoreKindT[],
): Promise<Partial<Record<UserScoreKindT, UserScoreT>>> {
  if (!IS_CLIENT_SIDE) throw Error('Client-side only');

  const res = await axios<GetLatestUserScoresResT>(
    `${P_API_USERS}/${userId}${E_SCORES}`,
    { params: { kinds } satisfies GetLatestUserScoresQueryT },
  );

  return res.data;
}
